import React, { FC, SVGProps } from 'react';

export const Alert: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0)">
      <path
        d="M6.90182 6.57917L7.09643 9.693C7.09643 9.88761 7.23544 9.99882 7.43006 9.99882H8.56994C8.73675 9.99882 8.90357 9.85981 8.90357 9.693L9.09818 6.57917C9.09818 6.38455 8.95917 6.21774 8.76456 6.21774H7.23544C7.04083 6.21774 6.90182 6.38455 6.90182 6.57917ZM9.18159 11.5557C9.18159 10.9163 8.65335 10.388 8.0139 10.388C7.34665 10.388 6.84622 10.9163 6.84622 11.5557C6.84622 12.223 7.34665 12.7234 8.0139 12.7234C8.65335 12.7234 9.18159 12.223 9.18159 11.5557ZM9.15378 1.547C8.65335 0.685138 7.34665 0.657336 6.84622 1.547L0.173729 13.1404C-0.326708 14.0023 0.312739 15.1144 1.34141 15.1144H14.6586C15.6873 15.1144 16.3267 14.0301 15.8263 13.1404L9.15378 1.547ZM1.48042 13.5575L7.84709 2.49227C7.9305 2.38106 8.06951 2.38106 8.15291 2.49227L14.5196 13.5575C14.603 13.6687 14.5196 13.7799 14.3806 13.7799H1.61943C1.48042 13.7799 1.39702 13.6687 1.48042 13.5575Z"
        fill={props.fill || '#181919'}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
